import { render, staticRenderFns } from "./DougnutChart.vue?vue&type=template&id=1b95ad9c&"
import script from "./DougnutChart.vue?vue&type=script&lang=js&"
export * from "./DougnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports